import React from 'react';
import { number } from 'prop-types';

const DeleteIcon = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="mask0_303_25167" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="21">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.000366211 4.50647H20.0894V6.297H0.000366211V4.50647Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_303_25167)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.194 6.297H0.895103C0.400366 6.297 0.000366211 5.89594 0.000366211 5.40121C0.000366211 4.90752 0.400366 4.50647 0.895103 4.50647H19.194C19.6888 4.50647 20.0898 4.90752 20.0898 5.40121C20.0898 5.89594 19.6888 6.297 19.194 6.297"
        fill="#AAA2AA"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.95874 4.50632H13.5208V2.52316C13.5208 2.11895 13.1924 1.79053 12.7882 1.79053H7.69137C7.28716 1.79053 6.95874 2.11895 6.95874 2.52316V4.50632ZM15.3124 6.29684H5.16821V2.52316C5.16821 1.13158 6.30084 0 7.69137 0H12.7882C14.1798 0 15.3124 1.13158 15.3124 2.52316V6.29684Z"
      fill="#AAA2AA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.94084 21.0575C3.44295 21.0575 2.224 19.8386 2.224 18.3407V8.61539C2.224 8.12066 2.624 7.7196 3.11874 7.7196C3.61347 7.7196 4.01453 8.12066 4.01453 8.61539V18.3407C4.01453 18.8512 4.42926 19.267 4.94084 19.267H15.3598C15.8703 19.267 16.2851 18.8512 16.2851 18.3407V8.61539C16.2851 8.12066 16.6861 7.7196 17.1808 7.7196C17.6756 7.7196 18.0766 8.12066 18.0766 8.61539V18.3407C18.0766 19.8386 16.8577 21.0575 15.3598 21.0575H4.94084Z"
      fill="#AAA2AA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.16715 17.0731C7.67241 17.0731 7.27136 16.672 7.27136 16.1773V10.8141C7.27136 10.3194 7.67241 9.91833 8.16715 9.91833C8.66189 9.91833 9.06294 10.3194 9.06294 10.8141V16.1773C9.06294 16.672 8.66189 17.0731 8.16715 17.0731"
      fill="#AAA2AA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.133 17.0731C11.6382 17.0731 11.2372 16.672 11.2372 16.1773V10.8141C11.2372 10.3194 11.6382 9.91833 12.133 9.91833C12.6277 9.91833 13.0288 10.3194 13.0288 10.8141V16.1773C13.0288 16.672 12.6277 17.0731 12.133 17.0731"
      fill="#AAA2AA"
    />
  </svg>
);

DeleteIcon.defaultProps = {
  width: 21,
  height: 22,
};

DeleteIcon.propTypes = {
  width: number,
  height: number,
};

export default DeleteIcon;
